var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklistIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "36px",
    viewBox: "0 0 29 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checklist icon_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-2.1%",
    y: "-2.4%",
    width: "104.2%",
    height: "104.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create-Site-Entrance/Exit-Entry",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Walk-in-2--Manual-temp-LKC-1636",
    transform: "translate(-491.000000, -524.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    filter: "url(#filter-1)",
    transform: "translate(456.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(24.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/checklist_btn",
    transform: "translate(8.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checklist-icon_white",
    transform: "translate(7.875000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03266591,20.4029198 L16.8831614,20.4029198 L16.8831614,19.3491982 L9.03266591,19.3491982 L9.03266591,20.4029198 Z M7.36167273,17.9735813 L4.99990909,20.2884855 L3.89247955,19.203314 L3.13193864,19.9481292 L4.99990909,21.7787171 L8.122275,18.7186971 L7.36167273,17.9735813 Z M9.03266591,15.0458552 L16.8831614,15.0458552 L16.8831614,13.9921336 L9.03266591,13.9921336 L9.03266591,15.0458552 Z M7.36167273,12.6162762 L4.99990909,14.9312405 L3.89247955,13.8460089 L3.13193864,14.5910646 L4.99990909,16.421412 L8.122275,13.3616325 L7.36167273,12.6162762 Z M9.03266591,9.68879065 L16.8831614,9.68879065 L16.8831614,8.63500891 L9.03266591,8.63500891 L9.03266591,9.68879065 Z M7.36167273,7.25927171 L4.99990909,9.57417595 L3.89247955,8.48894432 L3.13193864,9.234 L4.99990909,11.0643474 L8.122275,8.00456793 L7.36167273,7.25927171 Z M1.57170682,2.07412918 C0.701079545,2.07412918 0,2.76121604 0,3.61433185 L0,25.4235969 C0,26.2769532 0.701079545,26.963559 1.57170682,26.963559 L18.4433318,26.963559 C19.3142045,26.963559 20.0151,26.2769532 20.0151,25.4235969 L20.0151,11.9310712 L18.3711682,12.7875367 L18.3711682,23.1314833 C18.3711682,23.6707617 17.9066455,24.1048664 17.3297045,24.1048664 L2.68533409,24.1048664 C2.10839318,24.1048664 1.64411591,23.6707617 1.64411591,23.1314833 L1.64411591,6.58180624 C1.64411591,6.04246771 2.10839318,5.60836303 2.68533409,5.60836303 L17.3297045,5.60836303 C17.9066455,5.60836303 18.3711682,6.04246771 18.3711682,6.58180624 L18.3711682,12.7875367 L20.0151,11.9310712 L20.0151,3.61433185 C20.0151,2.76121604 19.3142045,2.07412918 18.4433318,2.07412918 L15.9384682,2.07412918 L15.9384682,2.63319154 C15.9384682,3.71253007 15.0381409,4.59481069 13.9364795,4.59481069 L6.07855909,4.59481069 C4.97714318,4.59481069 4.07681591,3.71253007 4.07681591,2.63319154 L4.07681591,2.07412918 L1.57170682,2.07412918 Z M6.07855909,0 C5.20799318,0 4.50709773,0.68708686 4.50709773,1.54020267 L4.50709773,2.63319154 C4.50709773,3.48630735 5.20799318,4.17315367 6.07855909,4.17315367 L13.9364795,4.17315367 C14.8070455,4.17315367 15.5079409,3.48630735 15.5079409,2.63319154 L15.5079409,1.54020267 C15.5079409,0.68708686 14.8070455,0 13.9364795,0 L6.07855909,0 Z",
    id: "Fill-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIconWhite);
export default __webpack_public_path__ + "static/media/checklist_icon_white.8582976752809c2343ac808328abfabd.svg";
export { ForwardRef as ReactComponent };